/* eslint-disable dot-notation */
import { createAsyncThunk, createSlice, current } from '@reduxjs/toolkit';
import { toast } from 'react-hot-toast';
import API from '../../Services/API';
import Cookies from 'js-cookie';
//
// @params data.type user_vendor or all_vendors
//
export const LoadVendorsRequest = createAsyncThunk(
  'vendor/load',
  async (data, { rejectWithValue }) => {
    try {
      const params = {
        company_id: data.companyId || process.env.REACT_APP_COMP_EMM,
        $filter: '',
        $count: true
      };
      if (data.type === 'user_vendor') {
        let filter = '';
        if (data.vendors.length > 0) {
          data.vendors.forEach((vendor, index) => {
            if (index === 0) {
              filter = `vendNo eq '${vendor.code}'`;
            } else {
              filter = filter + ` or vendNo eq '${vendor.code}'`;
            }
          });
          params.$filter = filter;
        } else {
          params.$filter = 'enableVendorPortal eq true';
        }
      } else {
        params.$filter = 'enableVendorPortal eq true';
      }
      const res = await API().get('/vendor_list', { params });
      let vendors = [];
      if (res.status === 200) {
        vendors = res.data.value.filter((v) => v.VendorType.trim() !== '');
      }
      if (vendors.length > 0) {
        return {
          vendors,
          type: data.type,
          action: data.action
        };
      } else {
        if (res.response.status === 200) {
          const vendors = res.data.value.filter((v) => v.VendorType.trim() === '');
          vendors.forEach((v) => {
            toast.error(`Invalid VendorType for ${v.companyBadgeText}-${v.vendNo}`, {
              id: v.vendNo
            });
          });
        }
        rejectWithValue('Invalid VendorType');
      }
    } catch (error) {
      console.log('error ', error);
    }
  }
);

const initialState = {
  currentVendor: {},
  userVendors: [],
  vendorList: [],
  fetchingVendors: false
};

const vendorSlice = createSlice({
  name: 'vendor',
  initialState,
  reducers: {
    UpdateCurrentVendor: (state, { payload }) => {
      if (Object.keys(payload).length > 0) {
        state.currentVendor = payload;
      }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(LoadVendorsRequest.pending, () => {
      return {
        ...initialState,
        fetchingVendors: true
      };
    });
    builder.addCase(LoadVendorsRequest.fulfilled, (state, { payload }) => {
      if (payload !== undefined) {
        if (payload.type === 'user_vendor') {
          const dedup = {};
          let userVendors = [...state.userVendors];
          payload.vendors.forEach((vendor) => {
            if (vendor.VendorType === 'Hybrid') {
              userVendors.push({
                ...vendor,
                VendorType: 'Warehouse',
                vendName: `${vendor.vendName} (W)`
              });
              userVendors.push({
                ...vendor,
                VendorType: 'Supplier',
                vendName: `${vendor.vendName} (S)`
              });
            } else {
              userVendors.push(vendor);
            }
          });
          userVendors = userVendors.filter((vendor) => {
            const key = `${vendor.companyBadgeText}_${vendor.vendNo}_${vendor.VendorType}`;

            if (dedup[key]) {
              return false;
            }

            if (vendor.VendorType === 'Warehouse' || vendor.VendorType === 'Supplier') {
              dedup[key] = true;

              return true;
            }

            return false;
          });
          state.userVendors = userVendors.map((v, i) => {
            v.index = i;
            v.identifier = `${v.vendName} - ${v.VendorType} (${v.vendNo} - ${v.companyBadgeText})`;
            delete v['@odata.etag'];
            return v;
          });
          if (
            current(state).currentVendor === undefined ||
            Object.keys(current(state).currentVendor).length === 0
          ) {
            if (Cookies.get('currentVendor')) {
              const savedVendor = JSON.parse(Cookies.get('currentVendor'));
              if (Object.keys(savedVendor).length > 0) {
                const selectedVendorIndex = userVendors.findIndex(
                  (vend) =>
                    vend.vendName === savedVendor.vendName &&
                    vend.companyBadgeText === savedVendor.companyBadgeText
                );
                if (selectedVendorIndex !== -1) {
                  state.currentVendor = savedVendor;
                }
              } else {
                state.currentVendor = userVendors[0];
              }
            } else {
              state.currentVendor = userVendors[0];
            }
          }
        } else {
          const vendorList = [...state.vendorList];
          payload.vendors.forEach((v, i) => {
            vendorList.push({
              value: `${v.vendNo}-${v.companyBadgeText}`,
              vendNo: v.vendNo,
              label: `${v.vendName} (${v.vendNo} - ${v.companyBadgeText})`,
              entity: v.companyBadgeText
            });
          });
          state.vendorList = vendorList;
        }
      }
      state.fetchingVendors = false;
    });
    builder.addCase(LoadVendorsRequest.rejected, () => {
      return {
        ...initialState,
        fetchingVendors: false
      };
    });
    builder.addCase('auth/logout', () => {
      return initialState;
    });
  }
});

export default vendorSlice.reducer;
export const vendorActions = vendorSlice.actions;
